module.exports = __webpack_public_path__ + "img/testimonial_2.caf51665.png";